import { Environment } from 'src/Environment';
import { request } from 'src/services/request';

export interface CategoryHitDTO {
  category: string;
  category_description: string;
  description: string;
  fasttrack_mapping: string;
  mcc: string;
  name: string;
  sic: string;
  tags: string;
}

export interface CategoryHit {
  category: string;
  categoryDescription: string;
  description: string;
  fasttrackMapping: string;
  mcc: string;
  name: string;
  sic: string;
  tags: string;
}

export interface BusinessCategory {
  mcc: string;
  name: string;
  description: string;
  category: string;
  categoryDescription: string;
  sic: string;
  fastTrackMapping: string;
  tags: string;
}

const hitDTOToHit = (dto: CategoryHitDTO): CategoryHit => ({
  category: dto.category,
  categoryDescription: dto.category_description,
  description: dto.description,
  fasttrackMapping: dto.fasttrack_mapping,
  mcc: dto.mcc,
  name: dto.name,
  sic: dto.sic,
  tags: dto.tags,
});

export const getBusinessCategoriesFromSearch = async (
  search: string,
  abortController: AbortController,
) => {
  const baseUrl = Environment.current?.apiHost;
  const ENDPOINT = `/cloud/public-services/financial-services/v1/vodapay/smme/mcc/code?input=${search}`;

  return request(
    ENDPOINT,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController.signal,
      },
    },
    baseUrl,
    null,
    true,
    true,
  ).then((response) => {
    if (response.status !== 200) {
      // error
      return [];
    }

    const hits: CategoryHitDTO[] = response.result.data;

    return hits.map((hit) => hitDTOToHit(hit));
  });
};
